<template>
    <section>
      <Banner />
      <Question />
    </section>
</template>
  
  <script>
  import Banner from "./Banner";
  import Question from "./Question.vue";
  export default {
    metaInfo: {
      title: "Service Transfer FAQ | Flat Branch Servicing"
    },
    components: {
      Banner,
      Question
    }
  };
  </script>
  
  <style scoped lang="scss">
  section {
    scroll-behavior: smooth;
  }
  </style>